import { render, staticRenderFns } from "./largeDisease.vue?vue&type=template&id=851bc7d8&scoped=true"
import script from "./largeDisease.vue?vue&type=script&lang=js"
export * from "./largeDisease.vue?vue&type=script&lang=js"
import style0 from "./largeDisease.vue?vue&type=style&index=0&id=851bc7d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851bc7d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('851bc7d8')) {
      api.createRecord('851bc7d8', component.options)
    } else {
      api.reload('851bc7d8', component.options)
    }
    module.hot.accept("./largeDisease.vue?vue&type=template&id=851bc7d8&scoped=true", function () {
      api.rerender('851bc7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeDisease.vue"
export default component.exports